import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ScrollTop from "react-scrolltop-button";

import BreakdownList from "./BreakdownList";
import PlannedMaintenanceTaskList from "../PlannedMaintenanceList/PlannedMaintenanceTaskList";

import { Box, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import BuildIcon from "@mui/icons-material/Build";
import WarningIcon from "@mui/icons-material/Warning";
import { ArrowDropUp } from "@mui/icons-material";

// Sekme içerik paneli
const TabPanel = ({ children, value, index }) => (value === index ? <Box>{children}</Box> : null);

export default function Lists() {
    const theme = useTheme();
    const { t } = useTranslation("translation");
    const [value, setValue] = useState(parseInt(localStorage.getItem("l_tabValue")) || 0);

    useEffect(() => {
        localStorage.setItem("l_tabValue", value);
    }, [value]);

    const tabs = [
        { label: t("BreakdownList"), icon: <WarningIcon /> },
        { label: t("PlannedList"), icon: <BuildIcon /> },
    ];

    return (
        <Box>
            {/* Sekmeler */}
            <Box
                sx={{
                    overflowX: "auto",
                    px: 1,
                    py: 1,
                    background: "rgba(255, 255, 255, 0.1)",
                    backdropFilter: "blur(12px)",
                    position: "sticky",
                    top: 0,
                    zIndex: 100,
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center", // işte bu ortalar
                        gap: 1,
                        minWidth: "max-content", // scroll olmasına izin verir
                    }}
                >
                    {tabs.map((tab, index) => {
                        const isActive = value === index;

                        const iconWithColor = React.cloneElement(tab.icon, {
                            sx: {
                                fontSize: 20,
                                color: isActive ? "rgba(0, 88, 163, 0.9)" : "#999",
                            },
                        });

                        return (
                            <Button
                                key={index}
                                onClick={() => setValue(index)}
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    px: { xs: 1.5, sm: 3 },
                                    py: { xs: 0.8, sm: 1 },
                                    fontSize: { xs: "0.75rem", sm: "0.9rem" },
                                    fontWeight: "bold",
                                    color: isActive ? "#000" : "#333",
                                    borderBottom: isActive ? "3px solid rgba(0, 88, 163, 0.9)" : "3px solid transparent",
                                    borderRadius: 0,
                                    minWidth: "fit-content",
                                    flexShrink: 0,
                                    textTransform: "none",
                                }}
                            >
                                {iconWithColor}
                                {tab.label}
                            </Button>
                        );
                    })}
                </Box>
            </Box>

            {/* İçerikler */}
            <TabPanel value={value} index={0}>
                <BreakdownList />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <PlannedMaintenanceTaskList />
            </TabPanel>

            {/* Scroll to top */}
            <ScrollTop
                distance={100}
                speed={200}
                target={0}
                icon={<ArrowDropUp />}
                style={{
                    backgroundColor: "#BCC5C6",
                    borderRadius: "20px",
                    border: "2px solid #999",
                    color: "black",
                }}
            />
        </Box>
    );
}
